<edit-dialog (action)="signalAction($event)" [title]="title" class="flex flex-col">
  <ng-container edit-body class="text-black">
    <div id="_modal-CENTER" class="w-full p-1 border-b border-black flex justify-around modal-center">
      @if (state === "ready") {
        @if (hullClasses.size > 1) {
          <button (click)="splitByHullClass()">by Hull Class</button>
        }
        @if (shipClasses.size > 1) {
          <button (click)="splitByShipClass()">by Ship Class</button>
        }
        @if (speeds.size > 1) {
          <button (click)="splitBySpeed()">by Speed</button>
        }
        @if (damaged.length >= 1) {
          <button (click)="splitByDamage()">by Damage</button>
        }
        <button (click)="splitManually()">Manual</button>
      }
      <!-- -->
      @else {
        @if (state === "manual") {
          <button (click)="addManualFleet()">Add Fleet</button>
        }
        <button (click)="cancelSplit()">Cancel</button>
      }
    </div>
    <div id="_modal-CENTER" class="w-full flex modal-center">
      <div class="p-2 flex flex-col">
        <div class="py-1 border-black border-b-2">
          {{ baseFleet.fleetName }}
        </div>
        <table>
          @for (shipId of baseFleet.shipIds; track shipId) {
            <tr (click)="moveShip(baseFleet, shipId)">
              <td>{{ shipById[shipId]?.shipName }}</td>
              @if (state === "class") {
                <td>{{ shipById[shipId].hullClass }}</td>
              }
              @if (state === "speed") {
                <td>{{ shipById[shipId]["counts"]["speed"] }}</td>
              }
              @if (state === "damage") {
                <td>{{ shipById[shipId].ssd }}</td>
              }
            </tr>
          }
        </table>
      </div>

      @for (fleet of newFleets; track fleet) {
        <div class="p-1 border-0 border-black border-l-2 flex flex-col">
          <div class="flex py-1 border-black border-b-2">
            @if (state === "manual") {
              @if (selectedFleet === fleet) {
                <ism-svg class="w-8 h-8 block m-auto" [name]="'checkCircle'" [classString]="'w-8 h-8 text-green-600'"></ism-svg>
              }
              <!-- -->
              @else {
                <span class="w-8 h-8 block m-auto" (click)="selectedFleet = fleet">O</span>
              }
            }
            <input type="text" class="border border-black" [(ngModel)]="fleet.fleetName" />
          </div>
          <table>
            @for (shipId of fleet.shipIds; track shipId) {
              <tr (click)="moveShip(fleet, shipId)">
                <td>{{ shipById[shipId].shipName }}</td>
                @if (state === "class") {
                  <td>{{ shipById[shipId].hullClass }}</td>
                }
                @if (state === "speed") {
                  <td>{{ shipById[shipId]["counts"]["speed"] }}</td>
                }
                @if (state === "damage") {
                  <td>{{ shipById[shipId].ssd }}</td>
                }
              </tr>
            }
          </table>
        </div>
      }
    </div>
  </ng-container>
</edit-dialog>
